import React from 'react';
import { Box, Button, FormControl, MenuItem, Select, Typography } from '@mui/material';
import { UnfoldLess, UnfoldMore } from '@mui/icons-material';
import ExportCsvButton from './ExportCsvButton';
import TouchTooltip from '../../common/TouchTooltip';
import { oneSidedNote, sortOptions } from '../../../utils/buyerInsightsFormat';

// One row above the list (spec §2.1 / §2.5): the one-sided note (the only place it appears),
// Sort by on narrow screens, Expand all / Collapse all, Export CSV.
// `options` overrides the Products sort columns (Brands); `hideExpand` drops Expand all (Brands you don't carry).
const ListToolbar = ({
  side,
  isWide,
  sort,
  onSort,
  allExpanded,
  onToggleAll,
  expandDisabled,
  expandAllNote,
  exportProps,
  options: optionsOverride,
  hideExpand = false,
}) => {
  const note = oneSidedNote(side);
  const options = optionsOverride || sortOptions(side);
  const tap = isWide ? 36 : 44;
  const expandAll = (
    <Button
      size="small"
      variant="text"
      onClick={onToggleAll}
      disabled={expandDisabled}
      startIcon={allExpanded ? <UnfoldLess /> : <UnfoldMore />}
      sx={{ minHeight: tap }}
    >
      {allExpanded ? 'Collapse all' : 'Expand all'}
    </Button>
  );
  return (
    <Box sx={{ display: 'flex', flexDirection: isWide ? 'row' : 'column', alignItems: isWide ? 'center' : 'stretch', gap: 1, mb: 1 }}>
      {note && (
        <Typography variant="caption" color="text.secondary" sx={{ flexGrow: isWide ? 1 : 0 }}>
          {note}
        </Typography>
      )}
      {isWide && !note && <Box sx={{ flexGrow: 1 }} />}
      <Box sx={{ display: 'flex', gap: 1, alignItems: 'center', justifyContent: isWide ? 'flex-end' : 'space-between', flexWrap: 'wrap' }}>
        {!isWide && options.length > 0 && (
          <FormControl size="small" sx={{ minWidth: 180, '& .MuiInputBase-root': { minHeight: tap } }}>
            <Select value={sort} onChange={(e) => onSort(e.target.value)} inputProps={{ 'aria-label': 'Sort by' }}>
              {options.map((o) => (
                <MenuItem key={o.value} value={o.value}>{`Sort: ${o.label.charAt(0).toLowerCase() + o.label.slice(1)}`}</MenuItem>
              ))}
            </Select>
          </FormControl>
        )}
        {hideExpand ? null : expandDisabled && expandAllNote ? (
          <TouchTooltip title={expandAllNote}>
            <span>{expandAll}</span>
          </TouchTooltip>
        ) : (
          expandAll
        )}
        <ExportCsvButton {...exportProps} minHeight={tap} />
      </Box>
    </Box>
  );
};

export default ListToolbar;
